import * as React from "react"

import { cn } from "@/lib/utils"

// shadcn Skeleton primitive, adapted to the repo's skeleton convention:
// pulsing `bg-muted` blocks that respect prefers-reduced-motion.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("rounded-md bg-muted motion-safe:animate-pulse", className)}
      {...props}
    />
  )
}

export { Skeleton }
